var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
const InfoTooltip = styled((_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement(Tooltip, Object.assign({}, props, { classes: { popper: className }, disableTouchListener: false, enterTouchDelay: 0, leaveTouchDelay: 3000 })));
})(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#009739',
        color: '#FCFBF5',
        maxWidth: 200,
        fontSize: '12px',
        border: '1px solid #009739',
        lineHeight: '18px',
        padding: '8px',
        textAlign: 'center',
    },
}));
export default InfoTooltip;
